<template>
    <a class="product-tile-widget" href="javascript:void(0);" title="Add"
        :key="item.itemID[sessionStore.storeNum]"
        :class="{'has-case': item.hasCase[sessionStore.storeNum] > 0, 'has-value': getHasValue, 'is-active': isActive}"
         @click="setActiveState"
        data-primary="0"
        :data-id="item.itemID[sessionStore.storeNum]"
        :data-sfitem="item.usfitem"
        :data-name="itemDesc"
        :data-unitprice="item.unitSellPrice[sessionStore.storeNum]"
        :data-unitreg="item.unitRegPrice[sessionStore.storeNum]"
        :data-caseprice="item.caseSellPrice[sessionStore.storeNum]"
        :data-casereg="item.caseRegPrice[sessionStore.storeNum]"
        :data-scaleitem="item.scaleItem[sessionStore.storeNum]"
        :data-multiply="item.toMultiply[sessionStore.storeNum]"
        :data-sale="item.showSpecial[sessionStore.storeNum]"
        :data-image="item.image"
        :data-limit="getUnitLimit"
        :data-queryID="props.item.__queryID">
    
        <span class="product-tile-widget-add">Add</span>

        <div class="product-tile-widget-count flex-col">
            <div class="count-row" :class="{'is-active': getUnitQty > 0}">
                <span class="count-label">Unit</span>
                <span class="count-value count-value-unit" :class="`count-value-` + getQtyLength">{{ getUnitQty }}</span>
            </div>
            <div class="count-row" :class="{'is-active': getCaseQty > 0}">
                <span class="count-label">Case</span>
                <span class="count-value count-value-case" :class="`count-value-` + getQtyLength">{{ getCaseQty }}</span>
            </div>
        </div>
        
        <div class="product-controls flex-col">
            <div class="product-controls-row flex-row" :class="`gap-` + getGap">
                <div class="product-tile-widget-text flex-col">Unit</div>
                <div class="product-tile-widget-btn flex-col">
                    <button type="button" class="product-tile-widget-button button-minus button-unit" data-ref="product-tile-widget"
                        :disabled="getUnitDisabled || getUnitQty <= 0"
                        @click="setQty($event, 'unit', false)"
                    >-</button>
                </div>
                <div class="product-tile-widget-quantity flex-col" :class="`product-tile-widget-quantity-` + getQtyLength">
                    <input type="number" name="unitQty" class="input-unit" maxlength="4" min="0" max="1000" step="1" data-ref="product-tile-widget"
                        :value="getUnitQty"
                        @change="handleUnitChange"
                    />
                </div>
                <div class="product-tile-widget-btn flex-col">
                    <button type="button" class="product-tile-widget-button button-add button-unit" data-ref="product-tile-widget"
                        :disabled="getUnitDisabled || (getUnitLimit > 0 && getUnitQty >= getUnitLimit)"
                        @click="setQty($event, 'unit', true)"
                    >+</button>
                </div>
            </div>

            <div class="product-controls-row flex-row" :class="`gap-` + getGap">
                <div class="product-tile-widget-text flex-col">Case</div>
                <div class="product-tile-widget-btn flex-col">
                    <button type="button" class="product-tile-widget-button button-minus button-case" data-ref="product-tile-widget"
                        :disabled="getCaseDisabled || getCaseQty <= 0"
                        @click="setQty($event, 'case', false)"
                    >-</button>
                </div>
                <div class="product-tile-widget-quantity flex-col" :class="`product-tile-widget-quantity-` + getQtyLength">
                    <input type="number" name="caseQty" class="input-case" maxlength="4" min="0" max="1000" step="1" data-ref="product-tile-widget"
                        :value="getCaseQty" 
                        oninput="validity.valid||(value='0');"
                        @change="handleCaseChange"
                    />
                </div>
                <div class="product-tile-widget-btn flex-col">
                    <button type="button" class="product-tile-widget-button button-add button-case" data-ref="product-tile-widget"
                        :disabled="getCaseDisabled"
                        @click="setQty($event, 'case', true)"
                    >+</button>
                </div>
            </div>
        </div>
    </a>
    <span v-if="item.lowStock[sessionStore.storeNum] > 0 && sessionStore.hasStore" class="low-stock tile-low-stock">Low stock</span>
</template>

<script setup>
    import { computed, ref } from 'vue';
    import { useSessionStore } from "@/store/storeSession.js";
    import { initAlgoliaInsights, sendAlgoliaEvent } from "@/utils/algoliaInsights.js";

    const sessionStore = useSessionStore();

    initAlgoliaInsights(sessionStore);

    const props = defineProps({
        item: {
            type: Object,
            required: true,
            default: () => ({
                itemID: 0,
                usfitem: '',
                itemDesc1: '',
                itemDesc2: '',
                itemDescStore: [],
                unitSellPrice: [0],
                unitRegPrice: [0],
                caseSellPrice: [0],
                caseRegPrice: [0],
                scaleItem: [0],
                toMultiply: [1],
                showSpecial: [0],
                image: '',
                hasCase: [0],
                itemSize: [],
                pack: [0],
                showUnitSale: [0],
                showCaseSale: [0],
                isExclusiveBrand: [0],
                unitSavings: [0],
                caseSavings: [0],
                itemExists: [1],
                lowStock: [0]
            })
        },
        itemDesc: String
    });

    const getUnitDisabled = computed(() => {
        let isFrozenCategory = [
            'frozen', 'fzn', 'ICE CREAM, HARD PACKED', 'ICE CREAM, CUPS & NOVELTIES'
        ].some(keyword => 
            (props.itemDesc && props.itemDesc.toLowerCase().includes(keyword)) || 
            (props.item.category && props.item.category.toLowerCase().includes(keyword)) || 
            (props.item.area[sessionStore.storeNum] && props.item.area[sessionStore.storeNum].toLowerCase().includes(keyword))
        );
        let isFreezerClosed = sessionStore.userStore.freezerClosed == "1"; 
        let isFreezerClosedCase = sessionStore.userStore.freezerClosedCase == "1";
        let thisHasCase = props.item.hasCase[sessionStore.storeNum] == "1";

        let isUnitDisabled = isFreezerClosed && isFrozenCategory && (thisHasCase || !isFreezerClosedCase);

        return isUnitDisabled;
    });

    const getCaseDisabled = computed(() => {
        let isUnitDisabled = getUnitDisabled.value;
        let isCaseDisabled = isUnitDisabled && sessionStore.userStore.freezerClosedCase == "1";

        return isCaseDisabled;
    });

    const getUnitLimit = computed(() => {
        let limit = props.item.hasCase[sessionStore.storeNum] == "1" ? props.item.pack[sessionStore.storeNum] - 1 : 0

        return limit;
    });

    const getUnitQty = computed(() => {
        let quantity = 0;

        if (sessionStore.userCartItems[props.item.usfitem])
            quantity = sessionStore.userCartItems[props.item.usfitem].itemQty;

        return quantity;
    });

    const getCaseQty = computed(() => {
        let quantity = 0;

        if (sessionStore.userCartItems[props.item.usfitem])
            quantity = sessionStore.userCartItems[props.item.usfitem].caseQty;

        return quantity;
    });

    const getQtyLength = computed(() => {
        let qtyLength = 1,
            unitQtyLength = 1,
            caseQtyLength = 1;

        if (sessionStore.userCartItems[props.item.usfitem]) {
            unitQtyLength = String(sessionStore.userCartItems[props.item.usfitem].itemQty).length;
            caseQtyLength = String(sessionStore.userCartItems[props.item.usfitem].caseQty).length;

            qtyLength = unitQtyLength > caseQtyLength ? unitQtyLength : caseQtyLength;
        }

        return qtyLength;
    });

    const getHasValue = computed(() => {
        let hasValue = false;

        if (sessionStore.userCartItems[props.item.usfitem] && (getUnitQty.value > 0 || getCaseQty.value > 0))
            hasValue = true;

        return hasValue;
    });

    const previousUnitQty = ref(getUnitQty.value);
    const previousCaseQty = ref(getCaseQty.value);

    function handleUnitChange(event, qty) {
        const currentValue = qty != undefined ? qty : parseInt(event.target.value) || 0;
        const upOrDown = currentValue > previousUnitQty.value ? 'qtyUp' : 'qtyDown';

        sendEvent(currentValue, 'unit', upOrDown);

        previousUnitQty.value = currentValue;
    }

    function handleCaseChange(event, qty) {
        const currentValue = qty != undefined ? qty : parseInt(event.target.value) || 0;
        const upOrDown = currentValue > previousCaseQty.value ? 'qtyUp' : 'qtyDown';

        sendEvent(currentValue, 'case', upOrDown);

        previousCaseQty.value = currentValue;
    }

    function setQty(event, unitOrCase, isIncrease) {
        if(unitOrCase == 'case') {
            const newValue = isIncrease == true ? getCaseQty.value + 1 : getCaseQty.value - 1;
            // sessionStore.userCartItems[props.item.usfitem].caseQty = newValue;
            handleCaseChange(event, newValue);
        } else {
            const newValue = isIncrease == true ? getUnitQty.value + 1 : getUnitQty.value - 1;
            // sessionStore.userCartItems[props.item.usfitem].itemQty = newValue;
            handleUnitChange(event, newValue);
        }
    }

    const getGap = computed(() => {
        let thisGap = 8,
            inputLen = getQtyLength.value;

        switch(inputLen) {
			case 1:
				thisGap = 8;
				break;
			case 2:
				thisGap = 5;
				break;
			case 3:
				thisGap = 2;
				break;
			case 4:
				thisGap = 0;
				break;
			default:
				thisGap = 8;
		}

		return thisGap;
    });

    const isActive = ref(false);
    const setActiveState = () => {
        isActive.value = true;
    };

    function sendEvent(qty, unitOrCase, upOrDown) {
        if(!sessionStore.trackAlgolia)
            return;

        if(props.item.__queryID)
            sessionStore.setQueryID(props.item.__queryID, props.item.__position);

        sessionStore.getUserCartItems();
        let algoliaEvent = 'convertedObjectIDs';
        let unitQty = unitOrCase == 'unit' ? qty : getUnitQty.value;
        let caseQty = unitOrCase == 'case' ? qty : getCaseQty.value;
        let rawValue = (props.item.unitSellPrice[sessionStore.storeNum] * props.item.toMultiply[sessionStore.storeNum] * unitQty) + (props.item.caseSellPrice[sessionStore.storeNum] * props.item.toMultiply[sessionStore.storeNum] * caseQty);
        let value = (Math.round(rawValue * 100) / 100).toFixed(2);
        let aaData = {
                quantity: unitOrCase == 'unit' ? unitQty : caseQty,
                price: unitOrCase == 'unit' ? props.item.unitSellPrice[sessionStore.storeNum] : props.item.caseSellPrice[sessionStore.storeNum],
                btnMethod: upOrDown
            };

        sendAlgoliaEvent(sessionStore, algoliaEvent, {
            eventType: 'conversion',
            eventSubType: 'addToCart',
            eventName: 'AddToCart',
            queryID: props.item.__queryID,
            index: sessionStore.index,
            objectIDs: [props.item.objectID],
            userToken: sessionStore.userToken || "",
            authenticatedUserToken: sessionStore.authUserToken || "",
            value: value,
            currency: "USD",
            data: aaData
        });
    }
</script>

<style>

</style>